import React, { useEffect } from 'react';
import { IntlProvider, updateIntl } from 'react-intl-redux';
import { useDispatch, useSelector } from 'react-redux';

import { addMessagesToTranslation, defaultTranslations } from 'helpers/intl';
import { isEmpty } from 'lodash';
import { configFetch } from 'store/features';
import { RootState } from 'types';

export const I18nProvider = ({ children }: { children: React.ReactNode }): JSX.Element => {
  const dispatch = useDispatch();
  const i18nKeys = useSelector(configFetch.selectors.getI18nKeys);
  const currentTranslations = useSelector((state: RootState) => state.intl);

  const handleUpdate = (newMessages?: Record<string, string>) => {
    if (isEmpty(currentTranslations?.messages)) {
      dispatch(updateIntl(defaultTranslations));
      return;
    }

    if (newMessages && !isEmpty(newMessages)) {
      const newTranslation = addMessagesToTranslation(currentTranslations, newMessages);

      dispatch(updateIntl(newTranslation));
    }
  };

  useEffect(() => {
    if (i18nKeys) {
      handleUpdate(i18nKeys);
    }
  }, [JSON.stringify(i18nKeys)]);

  useEffect(() => {
    handleUpdate();
  }, []);

  return <IntlProvider>{children}</IntlProvider>;
};
